export default {
  getBillData(state) {
    return state.billData;
  },
  getToken(state) {
    return state.user.base64EncodedAuthenticationKey;
  },
  getDailyUsage(state) {
    return state.dailyUsage;
  },
  isLogin(state) {
    return state.isLogin;
  },
  isloading(state) {
    return state.loading;
  },
  userDetail(state) {
    return state.userDetails;
  },
  getInvoiceList(state) {
    return state.invoiceList;
  },

  //TOPUP
  getTopupData(state) {
    return state.dataTopupList;
  },

  //MANAGE SERVICE
  getManageServiceList(state) {
    return state.manageList;
  },

  getPaymentList(state) {
    return state.paymentList;
  },
  getTransactionList(state) {
    return state.transactionList;
  },
  getTicketList(state) {
    return state.ticketList;
  },

  getBillDetailData(state) {
    return state.billDetail;
  },
  getInvoicesDetails(state) {
    return state.InvoList;
  },

  //HELP
  getTicketTemplate(state) {
    return state.ticketTemplate;
  }
};
